/* eslint-disable indent */
import React, { useContext } from 'react'
import { SectionHeader, Header2, Header3, Text } from '../../styles/Components'
import GiftCardContext from './GiftCardContext'
import { gsColors } from '../../styles/Variables'
import Input from '../Input'

const ChooseAmount = () => {
  const {
    state: {
      giftCardPrice,
      occasion,
      occasionError,
      personalMessage,
      priceData,
      occasionData,
      giftCardPriceError,
    },
    dispatch,
  } = useContext(GiftCardContext)

  return (
    <div className="choose-amount-container">
      <SectionHeader margin="0 0 9px 0" small>
        Step 2
      </SectionHeader>
      <Header2 margin="0 0 15px 0">Choose an amount</Header2>
      <Text color={gsColors.meredithGrey} lineHeight="144%">
        E-gift cards can be applied to any service. We&apos;ll add tax &
        gratuity to the price before checkout so that the recipient can apply
        your gift to their tax & gratuity as well.
      </Text>
      <div className="content">
        <div className="price-container">
          {priceData.map((p, i) => (
            <button
              key={i}
              data-testid="select-price-button"
              className={`gift-option-button ${giftCardPrice && giftCardPrice.price === p.price
                ? 'selected'
                : ''
                }`}
              onClick={() =>
                dispatch({
                  type: 'SET_GIFT_CARD_PRICE',
                  price: p,
                })
              }
            >
              ${p.price}
            </button>
          ))}
          <button
            data-testid="select-price-button"
            className={`gift-option-button custom-web ${giftCardPrice && giftCardPrice.custom ? 'selected' : ''
              }`}
            onClick={() =>
              dispatch({
                type: 'SET_GIFT_CARD_PRICE',
                price: { custom: true, price: '' },
              })
            }
          >
            Custom
          </button>
        </div>
        <div className="mobile-custom-button-container">
          <button
            data-testid="select-price-button"
            className={`gift-option-button custom-mobile ${giftCardPrice && giftCardPrice.custom ? 'selected' : ''
              }`}
            onClick={() =>
              dispatch({
                type: 'SET_GIFT_CARD_PRICE',
                price: { custom: true, price: '' },
              })
            }
          >
            Custom
          </button>
        </div>
        {!!giftCardPrice && giftCardPrice.custom && (
          <div className="custom-price-input-container">
            <Input
              isCash
              placeholder="Enter Custom Amount"
              value={giftCardPrice.price}
              onChange={({ target: { value } }) =>
                dispatch({
                  type: 'SET_GIFT_CARD_PRICE',
                  price: { custom: true, price: Number.parseFloat(value) },
                })
              }
            />
          </div>
        )}
        {giftCardPriceError && (
          <Text variant="small" color={gsColors.errorRed} margin="8px 0 0">
            Please select a price
          </Text>
        )}

        { giftCardPrice && !giftCardPrice.custom && (
          <Text margin='16px 0 0 0' color={gsColors.meredithGrey}>Suggested use: {giftCardPrice.suggestedUse}</Text>
        )}

        <Header3 fontSize={18} margin="55px 0 26px">
          What is the occasion?
        </Header3>
        <div className="occasion-container">
          {occasionData.map((o, i) => (
            <button
              key={i}
              className={`gift-option-button ${occasion && occasion === o ? 'selected' : ''
                }`}
              onClick={() =>
                dispatch({
                  type: 'SET_GIFT_CARD_OCCASION',
                  occasion: o,
                })
              }
            >
              {o}
            </button>
          ))}
        </div>
        {occasionError && (
          <Text variant="small" color={gsColors.errorRed} margin="8px 0 0">
            Please select an occasion
          </Text>
        )}
        <Header3 fontSize={18} margin="40px 0 26px">
          Personal Message
        </Header3>
        <textarea
          placeholder="Add a personal message (Optional)"
          className="personal-message"
          onChange={(e) =>
            dispatch({
              type: 'EDIT_PERSONAL_MESSAGE',
              personalMessage: e.target.value,
            })
          }
          value={personalMessage}
        />
      </div>
      <div className="divider" />
    </div>
  )
}

export default ChooseAmount
